import "./Register.css";
import React, { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { Formik, Form, Field } from "formik";
import { registerSchema } from "./RegisterValidation";

import BrandingImage from "assets/images/Group 48.png";
import ExpressionPink from "assets/images/expression-pink4.png";
import ExpressionGreen from "assets/images/expression-green2.png";
import SelectArrow from "assets/images/select_arrow.png";
import SuccessIcon from "assets/images/register-success-icon.png";
import HidePassword from "assets/images/eye-password-hide.png";
import ShowPassword from "assets/images/eye-password-show.png";

import Swal from 'sweetalert2'
import Loader from "utilities/reusableComponent/Loader/Loader";

function Register() {
  const navigate = useNavigate();
  const {userToken} = useSelector((state) => state.auth)

  const [dataSchools, setDataSchools] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Register form initial values
  let initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    confirm_email: "",
    school: "",
    password: "",
    other_school: ""
  }

  // Handling Navigate to login page
  let handleGoToLoginClick = () => {
    navigate("/login");
  };

  // Handling on Submit register form
  const onHandleSubmit = async (values) => {
    setLoading(true);
    let payload = {
      "email": values.email,
      "first_name": values.first_name,
      "last_name": values.last_name,
      "password": values.password,
      "school_uid": values.school === "other" ? "" : values.school,
    };

    // adjust school name if school selected is other
    if(values.school === "other") {
      payload.school = values.other_school
    }

    // Submit register data to API
    const res = await apiRequest({
      requestType: requestType.addTeacher,
      payload: {
        data: payload
      },
    });

    // Register API response
    if (res?.data?.status === 0) {
      // show success popup message when register is success
      const swalSuccessMessage = Swal.mixin({
        customClass: {
          popup: 'swal-success-popup',
          confirmButton: "swal-success",
          title: 'swal-title',
        },
        buttonsStyling: false,
        iconsStyling: false
      });
      swalSuccessMessage.fire({
        title: "Success!",
        html: "<p class='swal-text-html'>We have sent a verification email to your email. Please open your inbox and follow the link in order to verify your account. <br />Make sure to check your spam folder!</p>",
        imageUrl: SuccessIcon,
        imageWidth: 65,
        imageHeight: 60,
        confirmButtonText: "Login",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        }
      });
    } else {
      // show error popup meesage when register is failed
      const swalFailedMessage = Swal.mixin({
        customClass: {
          popup: 'swal-failed-popup',
          confirmButton: "swal-success",
          title: 'swal-title',
        },
        buttonsStyling: false,
      });
      swalFailedMessage.fire({
        title: "Failed!",
        html: `<p class='swal-text-html'>${res.data.error_message}</p>`,
        imageWidth: 65,
        imageHeight: 60,
        confirmButtonText: "Ok",
      });
    }
    setLoading(false);
  }

  // Get User Schools data from API
  const getSchools = async () => {
    const res = await apiRequest({
      requestType: requestType.getSchools,
      payload: {
        data: {}
      },
    });
    if (res?.data?.status === 0) {
      setDataSchools(res.data.data);
    }
  };

  // function to handling show or hide password
  const handlingShowPassword = () => {
    if(showPassword === true) {
      setShowPassword(false)
    } else {
      setShowPassword(true)
    }
  }

  useEffect(() => {
    // if user has login redirect to homepage
    if (userToken) {
      navigate("/home");
    }

    // get schools data
    getSchools();
  }, []);

  return (
    <Fragment>
      <div className="login mx-auto relative flex">
        <div className="w-full bg-white py-[100px] px-[50px]">
          <h3 className="text-4xl font-nunito font-bold text-center mb-[50px]">
            Welcome to Flow Minder
          </h3>
          <p className="text-[22px] text-center w-[501px] mx-auto mb-[50px]">
            Please enter your first name, last name, email address and school to
            register with Flow Minder
          </p>
          <Formik
            initialValues= {initialValues}
            validationSchema= {registerSchema}
            onSubmit={(values) => onHandleSubmit(values)}
          >
            {({errors, values, handleBlur, handleChange}) => {
              let isOtherSchool = false
              if(values.school === "other") {
                isOtherSchool = true;
              } else {
                isOtherSchool = false
              }
              return(
              <Form>
                <div className="w-[564px] mx-auto grid grid-cols-2 gap-y-[50px] gap-x-[25px]">
                  <div>
                    <p className="text-xl mb-2">First Name*</p>
                    <Field
                      type="text"
                      name="first_name"
                      placeholder="First Name"
                      className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                    />
                    {errors.first_name && <small className="text-red-500">{errors.first_name}</small>}
                  </div>
                  <div>
                    <p className="text-xl mb-2">Last Name*</p>
                    <Field
                      type="text"
                      name="last_name"
                      placeholder="Last Name"
                      className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                    />
                    {errors.last_name && <small className="text-red-500">{errors.last_name}</small>}
                  </div>
                  <div>
                    <p className="text-xl mb-2">Email Address*</p>
                    <Field
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                    />
                    {errors.email && <small className="text-red-500">{errors.email}</small>}
                  </div>
                  <div>
                    <p className="text-xl mb-2">Confirm Email Adress*</p>
                    <Field
                      type="text"
                      name="confirm_email"
                      placeholder="Email Address"
                      className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                    />
                    {errors.confirm_email && <small className="text-red-500">{errors.confirm_email}</small>}
                  </div>
                  <div className="col-span-2">
                    <p className="text-xl mb-2">School*</p>
                    <select
                      name="school"
                      value={values.school}
                      onBlur={handleBlur}
                      onChange={handleChange}

                      style={{ "--image-url": `url(${SelectArrow})` }}
                      className="rounded-[99px] w-full  pr-[60px] box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] appearance-none bg-[image:var(--image-url)] bg-no-repeat bg-[right_28px_center] bg-[length:10.235px_5.942px]"

                    >
                      <option value="" className="text-form-placeholder-color text-[#e8e8e8]">
                        Select School
                      </option>
                      {dataSchools.map((item) => (
                        <option value={item.uid.toString()} key={item.uid} className="text-form-placeholder-color">
                          {item.name}
                        </option>
                      ))}
                      <option value="other" className="text-form-placeholder-color text-[#e8e8e8]">
                        Other
                      </option>
                    </select>
                    {isOtherSchool && (
                      <>
                        <Field
                          type="text"
                          name="other_school"
                          placeholder="School Name"
                          className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] mt-[30px] text-form-color placeholder:text-form-placeholder-color"
                        />
                        {errors.other_school && <small className="text-red-500">{errors.other_school}</small>}
                      </>
                    )}

                    {errors.school && <small className="text-red-500">{errors.school}</small>}
                  </div>
                  <div className="col-span-2">
                    <div className="flex justify-end items-center relative">
                      <div className="w-full">
                        <p className="text-xl mb-2">Create Password*</p>
                        <Field
                          type={showPassword === true ? 'text' : 'password'}
                          name="password"
                          placeholder="*************"
                          className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                        />
                      </div>
                      <div className="w-[24px] h-[24px] absolute mr-6 mt-[35px] flex-shrink-0 cursor-pointer" onClick={handlingShowPassword}>
                        <img
                          src= {showPassword === true ? HidePassword : ShowPassword}
                          width={24}
                          height="auto"
                        />
                      </div>
                    </div>  
                    {errors.password && <small className="text-red-500">{errors.password}</small>}
                  </div>
                  <div className=" col-span-2 rounded-[67.491px] py-[22px] text-custom-navy border-[0.682px] border-custom-gray text-base font-bold text-center">
                    <button type="submit" className="w-[565px]">Register</button>
                  </div>
                  <div className="col-span-2">
                    <h3 className="text-2xl text-black font-bold text-center">
                      Already have an account?
                    </h3>
                  </div>
                  <div
                    className=" col-span-2 rounded-[67.491px] py-[22px] bg-custom-navy text-white text-base font-bold text-center cursor-pointer"
                    onClick={handleGoToLoginClick}
                  >
                    Login
                  </div>
                </div>
              </Form>
            )}}
          </Formik>
        </div>
        <aside className="w-[359px] flex-shrink-0 max-h-screen bg-yellow sticky right-0 top-0 h-screen overflow-hidden">
          <img
            src={BrandingImage}
            alt=""
            className="w-[199px] mt-[277px] mx-auto"
          />
          <img
            src={ExpressionPink}
            alt=""
            className="absolute w-[112px] bottom-[-15px] left-[-13px] z-0"
          />
          <img
            src={ExpressionGreen}
            alt=""
            className="absolute w-[91px] bottom-[-45px] right-[-12px] rotate-[-4.139deg] z-0"
          />
        </aside>
      </div>
      {loading && <Loader />}
    </Fragment>  
  );
}

export default Register;
